import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import { Translate, I18n } from 'react-redux-i18n';
import Form from 'components/Form';
import Button from 'components/Form/Button';
import Input, { TYPE_FILE } from 'components/Form/Input';
import FlexGroup from 'components/FlexGroup';
import { toggleErrorDialog } from 'actions';
import { ROOT } from 'constants/routes';
import { IMPORT_LIMIT_2MB, CSV_FILE } from 'constants/file';
import { NavLink } from 'react-router-dom';
import { useFilterImportMutation } from 'redux/hook/useFilter';

const FilterImportModal = ({
    show,
    onClose,
}) => {
    const dispatch = useDispatch();
    const [inProgress, setInProgress] = useState(false);
    const [file, setFile] = useState();
    const [uploadFile] = useFilterImportMutation();

    const handleFileChange = e => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        const ext = file.name.split('.').pop();

        if (ext !== CSV_FILE) {
            dispatch(toggleErrorDialog(I18n.t('file_type_csv_warning')));
            onClose();
            return;
        }

        if (file.size > IMPORT_LIMIT_2MB) {
            dispatch(toggleErrorDialog(I18n.t('file_size_MB_warning', { size: 2 })));
            onClose();
            return;
        }

        setFile(file);
    };
    const handleClose = e => {
        setFile();
        onClose();
    };

    const handleSubmit = async e => {
        e.preventDefault();

        setInProgress(true);

        try {
            const resp = await uploadFile(file);

            if (resp?.error) {
                throw resp.error;
            }
        }
        catch (error) {
            const { data, status } = error ?? {};
            const { code, message: filterId } = data ?? {};
            const message = (status === 409 && code !== undefined) ?
                I18n.t(`filters.import_error_${ code }`, { filterId }) :
                I18n.t('general_error_message');
            dispatch(toggleErrorDialog(message));
        }
        finally {
            setInProgress(false);
            setFile();
            onClose();
        }
    }
    return (
        <>
            {
                show ? (
                    <Modal
                        className="filter-import-modal"
                        title={ I18n.t('import') }
                        onClose={ handleClose }
                    >
                        <Form onSubmit={ handleSubmit } inProgress={ inProgress }>
                            <FlexGroup className="download-section">
                                <NavLink to={ `${ ROOT }filter-import-template.csv` } target="_blank" rel="noopener noreferrer">
                                    <Translate value="download＿tmpl" />
                                </NavLink>
                            </FlexGroup>
                            <Input
                                accept=".csv"
                                name="file"
                                caption="filters.browse_file"
                                type={ TYPE_FILE }
                                value={ file?.name || '' }
                                onChange={ handleFileChange }
                                required
                            />
                            <FlexGroup end>
                                <Button color="primary" type="submit">
                                    <Translate value="submit" />
                                </Button>
                            </FlexGroup>
                        </Form>
                    </Modal>
                ) : null
            }
        </>
    );
};

FilterImportModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
};
FilterImportModal.defaultProps = {
    show: false,
    onClose: () => {},
};

export default FilterImportModal;
